import { CancelToken } from 'axios'
import { isURL } from './HelperFunctions'
import { AccessToken } from './authUtils'

/**
 * Creates standard axios configuration for API requests
 */
export const createApiConfig = (cancelToken?: CancelToken) => ({
  headers: {
    ...AccessToken.requestHeaders(),
    'content-type': 'application/json'
  },
  cancelToken
})

/**
 * Builds full request URL from endpoint and domain
 */
export const buildRequestUrl = (endpoint: string, domain?: string) => {
  const baseUrl = isURL(endpoint)
    ? ''
    : domain || process.env.REACT_APP_REST_DOMAIN
  return `${baseUrl}${endpoint}`
}
